import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import * as R from 'remeda'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { HStack } from '~/components/elements/HStack'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import {
  type CustomerAttributeGroup,
  useSurveyQueryReferencedCustomerAttributeIds,
} from '~/hooks/useSurveyQuery'

import { dialogInfoAtom } from '../atoms'
import { useSurveyId } from '../hooks/useSurveyId'

export type CommandsCellProps = {
  dataItem: CustomerAttributeGroup
}

export const CommandsCell = ({
  dataItem: customerAttributeGroup,
}: CommandsCellProps) => {
  const { t } = useTranslation()
  const surveyId = useSurveyId()

  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleDeleteButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', customerAttributeGroup })
  }, [customerAttributeGroup, setDialogInfo])

  const referencedCustomerAttributeIds =
    useSurveyQueryReferencedCustomerAttributeIds()
  const idDisabledDeleteButton = React.useMemo(
    () =>
      0 <
      R.intersection(
        customerAttributeGroup.customerAttributes.map(R.prop('id')),
        referencedCustomerAttributeIds,
      ).length,
    [customerAttributeGroup.customerAttributes, referencedCustomerAttributeIds],
  )

  return (
    <td>
      <HStack backgroundColor="transparent" spacing={1}>
        <Link
          to={compile('customerAttributeList', {
            surveyId,
            customerAttributeGroupId: customerAttributeGroup.id,
          })}
        >
          <StyledButton fillMode="outline">
            {t('to_customized_segments_list')}
          </StyledButton>
        </Link>

        <StyledButton
          disabled={idDisabledDeleteButton}
          fillMode="outline"
          icon="delete"
          onClick={handleDeleteButtonClick}
        >
          {t('delete')}
        </StyledButton>
      </HStack>
    </td>
  )
}
